/**
 * 将 RGBA 转为 16进制颜色和透明度
 * @param {*} str 'rgba(265, 255, 222, 0.7)'
 */

export default function changeRgbaToHex(str) {
  if(!str) return {color: '#fff', opacity: 0}
  const colorArr = str.match(/(0\.)?\d+/g)
  let opacity = Number.parseFloat(colorArr[colorArr.length - 1]) || 1
  let color = colorArr.slice(0, 3).map((item => {
    return Number.parseFloat(item)      
          .toString(16)      
          .padStart(2, "0");
  })).join('')
  return {
    color: `#${color}`,
    opacity
  }
}